/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { useMutation, useQuery } from '@apollo/client';
import { ADDITIONAL_VENDORS_QUERY } from 'pages/Vendor/VendorGraphQL';
import {
  ASSIGN_TRADERS_TO_ANOTHER_BDE,
  ASSIGN_TRADERS_TO_ANOTHER_RM,
} from 'pages/Staff/StaffgraphQL';
import Loader from 'components/common/Loader';
import UserInfo from 'components/UserInfo';
import NoDataFound from 'components/NoDataFound';

const getFilters = (vendorList = []) => {
  if (Array.isArray(vendorList) && vendorList.length > 0) {
    const result = vendorList.join(',');
    return [
      {
        key: 'id',
        value: result,
        type: 'INT',
        op: 'NOT_IN',
      },
    ];
  }

  return [];
};

const AddAllocateVendorList = ({
  searchString,
  onCloseAddPopup,
  drawerToggle,
  id,
  roleList,
  vendorList,
}) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const buildSearchFilter = (value) => {
    const trimmedValue = `${value || ''}`.trim();
    if (!trimmedValue) return [];
    return [
      {
        key: 'traderSearchFilter',
        value: trimmedValue,
        type: 'STRING',
        op: 'LIKE',
      },
    ];
  };

  const { data, loading, error } = useQuery(ADDITIONAL_VENDORS_QUERY, {
    variables: {
      filter: [...buildSearchFilter(searchString), ...getFilters(vendorList)],
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  const [assignTradersToAnotherRM] = useMutation(ASSIGN_TRADERS_TO_ANOTHER_RM, {
    onCompleted: ({ assignTradersToAnotherRM }) => {
      if (assignTradersToAnotherRM?.status === 200)
        toast.success(assignTradersToAnotherRM?.message);
      onCloseAddPopup();
      drawerToggle();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      onCloseAddPopup();
      drawerToggle();
    },
  });

  const [assignTradersToAnotherBDE] = useMutation(
    ASSIGN_TRADERS_TO_ANOTHER_BDE,
    {
      onCompleted: ({ assignTradersToAnotherBDE }) => {
        if (assignTradersToAnotherBDE?.status === 200)
          toast.success(assignTradersToAnotherBDE?.message);
        onCloseAddPopup();
        drawerToggle();
      },
      onError: ({ graphQLErrors }) => {
        graphQLErrors.map(({ exception }) => {
          toast.error(exception?.message);
          return exception;
        });
        onCloseAddPopup();
        drawerToggle();
      },
    },
  );

  const handleCheckboxChange = (event, itemId) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, itemId]); // Add the selected item ID to the selectedItems array
    } else {
      setSelectedItems(selectedItems.filter((id) => id !== itemId)); // Remove the deselected item ID from the selectedItems array
    }
  };

  const handleAddChange = () => {
    if (roleList?.length > 0) {
      try {
        assignTradersToAnotherBDE({
          variables: {
            traders: selectedItems,
            dedicatedBDE: id,
          },
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        assignTradersToAnotherRM({
          variables: {
            traders: selectedItems,
            dedicatedRM: id,
          },
        });
      } catch (err) {
        console.error(err);
      }
    }
  };

  if (loading)
    return (
      <div className="text-center mt-3">
        <Loader />
      </div>
    );
  if (error) return `There is an error on this page : ${error.message} `;

  if (!data?.traders?.traders?.length)
    return <NoDataFound message="No data found" />;

  return (
    <div className="vednor-list mt-3">
      <Button
        onClick={handleAddChange}
        size="sm"
        className="fixed-top-btn small-btn px-4"
        color="primary"
        disabled={!selectedItems.length}
      >
        Add
      </Button>

      {data?.traders?.traders?.map((item) => (
        <div key={item.id} className="d-flex align-items-center user-data">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selectedItems.includes(item.id)} // Check if the item is selected
              onChange={(event) => handleCheckboxChange(event, item.id)} // Call handleCheckboxChange with item ID
            />
          </div>
          <UserInfo
            name={item.firstName + ' ' + item.lastName}
            gstNumber={item?.phone ? item?.phone : '-'}
          />
        </div>
      ))}
    </div>
  );
};

export default AddAllocateVendorList;
